import { Address } from '../../../features/address'
import { Data2, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { VatCondition } from '../../administration'
import { Company, SalePoint } from '../state/types'

export const useCompanyBuilders = () => {
    const buildCompany = (data: Data2) => {
        const {
            id = newId(),
            code,
            name,
            legalName,
            taxIds,
            websiteUrl,
            email,
            phone,
            logoUrl,
            address,
            vatCondition,
            grossIncomeCode,
            activityStartDate
        } = data
        const company: Company = {
            id: id! as string,
            code: code! as string,
            name: name! as string,
            legalName: legalName! as string,
            taxIds: taxIds as { taxId: number; main: boolean; salePoint?: SalePoint, collectionAgentProvinces?: string[] }[],
            websiteUrl: websiteUrl as O<string>,
            email: email! as string,
            phone: phone as O<number>,
            logoUrl: logoUrl as O<string>,
            address: address! as Address,
            vatCondition: vatCondition! as VatCondition,
            grossIncomeCode: grossIncomeCode as O<number>,
            activityStartDate: activityStartDate as O<string>
        }

        return company
    }

    const buildSalePoint = (data: Data2) => {
        const { apiId, apiCompanyId, apiSubsidiaryId, code, fiscalId, taxId } = data
        const salePoint: SalePoint = {
            apiId: apiId! as number,
            apiCompanyId: apiCompanyId! as number,
            apiSubsidiaryId: apiSubsidiaryId! as number,
            code: code! as string,
            fiscalId: fiscalId! as number,
            taxId: taxId! as number
        }
        return salePoint
    }

    return {
        buildCompany,
        buildSalePoint
    }
}
